export default {
  'menu.dashboard.workplace': '工作台',
  'workplace.welcome': '欢迎回来，',
  'workplace.docs': '帮助文档',
  'workplace.announcement': '公告',
  'workplace.record.nodata': '暂无数据',
  'workplace.quick.operation': '快捷操作',
  'workplace.quickOperation.setup': '管理',
  'workplace.loadMore': '加载更多',
  'workplace.viewMore': '查看更多',
  'workplace.pecs': '个',
  'workplace.item': '条',
  'workplace.people': '人',

  // 星悦媄
  'workplace.todayFollowUp': '今日待回访',
  'workplace.todayClient': '今日客资',
  'workplace.followUpData': '7日回访数据',
  'workplace.myTotalClient': '我的总客户',
  'workplace.pendingStar': '待审核星推官',
  'workplace.pendingAppointments': '待处理预约',
  'workplace.todayReports': '今日报备数',
  'workplace.todayNewCustomers': '今日新增客户',
  'workplace.pendingReReports': '待重新报备',
};
